import axios from '@/core/axios';

import {
  OrderPerformanceLinesQuery,
  OrderPerformanceLinesResponse,
  OrderPerformanceQuery,
  OrderPerformanceResponse
} from './order-performance.types';

const compactParams = (params: object): Record<string, unknown> =>
  Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));

/* Module Analyses > Suivi > Performance commandes : tenue de l'échéance d'expédition par jour d'échéance */
export class OrderPerformanceService {
  summary(query: OrderPerformanceQuery = {}): Promise<OrderPerformanceResponse> {
    return axios
      .get<OrderPerformanceResponse>('/order-performances', { params: compactParams(query) })
      .then(resp => resp?.data);
  }

  /* Lignes d'un périmètre (paginées), sur la période ou un jour d'échéance précis */
  lines(query: OrderPerformanceLinesQuery): Promise<OrderPerformanceLinesResponse> {
    return axios
      .get<OrderPerformanceLinesResponse>('/order-performances/lines', { params: compactParams(query) })
      .then(resp => resp?.data);
  }
}

export const orderPerformanceService = new OrderPerformanceService();
